import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../../../services/CommonService';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})

export class SidebarComponent implements OnInit {
  subMenus: any;
  menus: any;
  @ViewChild('myname') input: ElementRef;

  constructor(private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router, ) {
  }

  reloadPage() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.getListSubMenu(this.input.nativeElement.value);
    }, 0);
  }

  ngOnInit(): void {
    // this.id = this.route.snapshot.paramMap.get('id');
    this.reloadPage();
    this.getListMenuBar();
    this.getListSubMenu(this.input.nativeElement.value);
  }

  //get list menu bar
  getListMenuBar() {
    this.commonService.getListMenuBar().snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ key: c.payload.key, ...c.payload.val() })
        )
      )
    ).subscribe(menus => {
      this.menus = menus;
    });
  }

  //get list sub menu
  getListSubMenu(id: String) {
    this.commonService.getListSubMenu(id).snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ key: c.payload.key, ...c.payload.val() })
        )
      )
    ).subscribe(subMenus => {
      this.subMenus = subMenus;
    });
  }


}
